/** Card-payment terminals rented to funds (HAT-1434). Values match the server's enums, which travel as strings. */

/** פנוי | שמור לפרויקט | מושכר | תקול | הוצא משימוש */
export enum PaymentDeviceStatus {
  Available = 'Available',
  Reserved = 'Reserved',
  Rented = 'Rented',
  Faulty = 'Faulty',
  Retired = 'Retired',
}

export enum PaymentDeviceLocation {
  Israel = 'Israel',
  US = 'US',
}

export enum PaymentDeviceRentalStatus {
  Reserved = 'Reserved',
  Active = 'Active',
  Returned = 'Returned',
  Cancelled = 'Cancelled',
}

export enum PaymentDevicePickupArea {
  Israel = 'Israel',
  US = 'US',
  Both = 'Both',
}

export enum PaymentDeviceRentalRequestStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
}

export enum PaymentDeviceRejectionReason {
  NoDevices = 'NoDevices',
  Other = 'Other',
}

/**
 * A monthly rental-fee charge (HAT-1434, part 3): written to APT, waiting, failed and retried,
 * computed only (an installation that does not write to APT), or not recorded (a US fund).
 */
export enum PaymentDeviceFeeChargeStatus {
  Pending = 'Pending',
  Written = 'Written',
  Failed = 'Failed',
  Simulated = 'Simulated',
  Skipped = 'Skipped',
}

export enum PaymentDeviceEventType {
  Created = 'Created',
  Updated = 'Updated',
  Assigned = 'Assigned',
  HandedOver = 'HandedOver',
  AssignmentCancelled = 'AssignmentCancelled',
  Returned = 'Returned',
  MarkedFaulty = 'MarkedFaulty',
  MarkedFixed = 'MarkedFixed',
  Retired = 'Retired',
}

/** What goes out with a terminal and should come back with it. Labels: paymentDevices.accessories.<value>. */
export enum PaymentDeviceAccessory {
  Case = 'Case',
  Wallet = 'Wallet',
  ChargerHead = 'ChargerHead',
  Cable = 'Cable',
}
